/* eslint-disable */
import { createContext, useEffect, useState } from 'react';
import { useAccount, useMsal } from '@azure/msal-react';
import { useSearchParams, useLocation } from 'react-router-dom';
import { useGetVendedorCode, useGetCoordenadorCode } from '../Pages/Granel/useGranel';
import { getUserTypeByEmail as getUserTypeByEmailCPP} from '../Services/CPPServices';
import { getUserTypeByEmail as getUserTypeByEmailIMO} from '../Services/IMOServices';
import { loginRequest, getAuthenticatedClient } from '../Config/authConfig';
export const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [user, setUser] = useState({});
  const [seller, setSeller] = useState({});
  const [coordinator, setCoordinator] = useState({});
  const [enableFetchCoordinator, setEnableFetchCoordinator] = useState(false);

  const { instance, accounts } = useMsal();
  const account = useAccount(accounts[0]);
  const [searchParams] = useSearchParams();

  const location = useLocation();
  const isGranel = location.pathname.startsWith('/granel');
  const isCPP = location.pathname.startsWith('/cpp');
  const isIMO = location.pathname.startsWith('/imo');

  const vendedorGranel = useGetVendedorCode(user?.employeeId);
  const coordenadorGranel = useGetCoordenadorCode(user?.employeeId, enableFetchCoordinator);

  async function getUserInfo() {
    let response = {};

    try {
      response = await instance.acquireTokenSilent({
        ...loginRequest,
        account: instance.getAllAccounts()[0],
      });
    } catch (e) {
      response = await instance.acquireTokenPopup(loginRequest);
    }

    const userInfo = await getAuthenticatedClient(
      account.localAccountId,
      response.accessToken,
    );

    const userAux = { ...userInfo, employeeId: userInfo?.employeeId || searchParams.get('sellerCode') || '' };
    const employeeId = userAux?.employeeId ? parseInt(userAux?.employeeId, 10).toString() : '';

    setUser({ ...userAux, employeeId });
    sessionStorage.setItem('user', JSON.stringify({ ...userAux, employeeId }));
  }

  useEffect(() => {
    getUserInfo();
    sessionStorage.setItem('account', JSON.stringify(account));
  }, []);

  // Granel
  useEffect(() => {
    if (isGranel && vendedorGranel?.data?.code !== undefined) {
      setSeller(vendedorGranel.data);
      sessionStorage.setItem('seller', JSON.stringify(vendedorGranel.data));
    } else if (isGranel && vendedorGranel?.isSuccess) {
      setEnableFetchCoordinator(true);
    }
  }, [isGranel, vendedorGranel?.data, vendedorGranel?.isSuccess]);

  useEffect(() => {
    if (isGranel && coordenadorGranel?.data?.code !== undefined) {
      setCoordinator(coordenadorGranel.data);
      sessionStorage.setItem('coordinator', JSON.stringify(coordenadorGranel.data));
    }
  }, [isGranel, coordenadorGranel?.data]);

  // CPP
  useEffect(() => {
    async function fetchUserTypeCPP() {
      if (isCPP && account?.username) {
        try {
          const response = await getUserTypeByEmailCPP(account?.username);
          if (response == 'Coordenador') {
            setCoordinator(true);
            setSeller(false);
          } else {
            setSeller(true);
            setCoordinator(false);
          }
        } catch (e) {
          console.error('Erro ao buscar userType do CPP:', e);
        }
      }
    }
    fetchUserTypeCPP();
  }, [isCPP, account]);

  // IMO
  useEffect(() => {
    async function fetchUserTypeIMO() {
      if (isIMO && account?.username) {
        try {
          const response = await getUserTypeByEmailIMO(account?.username);
          if (response == 'Coordenador') {
            setCoordinator(true);
            setSeller(false);
          } else {
            setSeller(true);
            setCoordinator(false);
          }
        } catch (e) {
          console.error('Erro ao buscar userType do IMO:', e);
        }
      }
    }
    fetchUserTypeIMO();
  }, [isIMO, account]);

  return (
    <AuthContext.Provider value={{ user, account, seller, coordinator }}>
      {children}
    </AuthContext.Provider>
  );
}
